import { render } from "./SolucoesView.vue?vue&type=template&id=5ee29639"
import script from "./SolucoesView.vue?vue&type=script&lang=js"
export * from "./SolucoesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__